/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18n } from './AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18n';
import {
    AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18nFromJSON,
    AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18nFromJSONTyped,
    AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18nToJSON,
} from './AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18n';
import type { ActionItemDto } from './ActionItemDto';
import {
    ActionItemDtoFromJSON,
    ActionItemDtoFromJSONTyped,
    ActionItemDtoToJSON,
} from './ActionItemDto';

/**
 * 
 * @export
 * @interface PossibleActionDto
 */
export interface PossibleActionDto {
    /**
     * 
     * @type {boolean}
     * @memberof PossibleActionDto
     */
    disabled?: boolean;
    /**
     * 
     * @type {AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18n}
     * @memberof PossibleActionDto
     */
    reason?: AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18n | null;
    /**
     * 
     * @type {ActionItemDto}
     * @memberof PossibleActionDto
     */
    action?: ActionItemDto;
    /**
     * 
     * @type {string}
     * @memberof PossibleActionDto
     */
    $type?: PossibleActionDtoTypeEnum;
}


/**
 * @export
 */
export const PossibleActionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoActionsPossibleActionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.Actions.PossibleActionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PossibleActionDtoTypeEnum = typeof PossibleActionDtoTypeEnum[keyof typeof PossibleActionDtoTypeEnum];


/**
 * Check if a given object implements the PossibleActionDto interface.
 */
export function instanceOfPossibleActionDto(value?: unknown): value is PossibleActionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PossibleActionDtoTypeEnum)[0];
}

export function PossibleActionDtoFromJSON(json: any): PossibleActionDto {
    return PossibleActionDtoFromJSONTyped(json, false);
}

export function PossibleActionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PossibleActionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'reason': !exists(json, 'reason') ? undefined : AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18nFromJSON(json['reason']),
        'action': !exists(json, 'action') ? undefined : ActionItemDtoFromJSON(json['action']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function PossibleActionDtoToJSON(value?: PossibleActionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'disabled': value.disabled,
        'reason': AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18nToJSON(value.reason),
        'action': ActionItemDtoToJSON(value.action),
        '$type': value.$type,
    });
}

